export class SeEmailConversationService {
    static extractConvoUuid(sendResponse: unknown): string | null {
        return (sendResponse as any)?.results?.result?.key ?? null;
    }
}
